export const ORDER_STATUSES = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  DONE: 'done',
  REJECTED: 'rejected',
} as const;

export type OrderStatus = (typeof ORDER_STATUSES)[keyof typeof ORDER_STATUSES];

export const ORDER_STATUS_VALUES = Object.values(ORDER_STATUSES) as [OrderStatus, ...OrderStatus[]];

const TRANSITIONS: Record<OrderStatus, readonly OrderStatus[]> = {
  [ORDER_STATUSES.PENDING]: [ORDER_STATUSES.IN_PROGRESS, ORDER_STATUSES.REJECTED],
  [ORDER_STATUSES.IN_PROGRESS]: [ORDER_STATUSES.DONE, ORDER_STATUSES.REJECTED],
  [ORDER_STATUSES.DONE]: [],
  [ORDER_STATUSES.REJECTED]: [],
};

export const ALLOWED_ORDER_TRANSITIONS: Readonly<Record<OrderStatus, readonly OrderStatus[]>> =
  Object.freeze(TRANSITIONS);

export const TERMINAL_ORDER_STATUSES: readonly OrderStatus[] = [ORDER_STATUSES.DONE, ORDER_STATUSES.REJECTED];

export function canTransitionOrder(from: OrderStatus, to: OrderStatus): boolean {
  return ALLOWED_ORDER_TRANSITIONS[from].includes(to);
}

export function isOrderClosed(status: OrderStatus): boolean {
  return TERMINAL_ORDER_STATUSES.includes(status);
}

export function nextOrderStatuses(from: OrderStatus): readonly OrderStatus[] {
  return ALLOWED_ORDER_TRANSITIONS[from];
}
